import FeaturedSolutions from "../../components/FeaturedSolutions";
import LogoMini from "../../components/icons/LogoMini";
import IGOnDemand from "../../assets/img/Featured/app-ondemand-food.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
const DormRoomsPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page splash dormRoomsPage">
            <div className="background" />
            <Header />
            <div className="page-header">Dorm Rooms</div>
            <div className="text-blocks">
                <div className="std-text">
                    Delight students with food and beverage at-a-click 
                    advanced ordering for pick-up anywhere on campus.{'\n\n'}
                </div>
                <div className="std-text">
                    Fast, easy, mobile ordering and payment drives order 
                    volume and enhances the student experience.{'\n\n'}
                </div>
                <div className="std-text">
                    Use Graphical KPI dashboards and reports to analyze 
                    performance and identify opportunities to improve 
                    service and operations.
                </div>
            </div>
            <FeaturedSolutions>
                <div
                  className="featured-item"
                  onClick={() => {
                    _logEvent("click", "Dorm Rooms", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand");
                  }}
                >
                  <div className="item-head">
                    <LogoMini />
                    IG OnDemand
                  </div>
                  <img src={IGOnDemand} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}

export default DormRoomsPage;